import {OmapiIdConstants} from '../shared/omapi-id-constants';
import {ImageUtils} from '../shared/utils/image/image-utils';

export class Order {
  static ORDER = 'order';
  static DAYPASS = 'daypass';
  static TRIALS = 'trials';

  packOmapiId: string;
  packPrice: number;
  subPackOmapiId: string;
  subPackPrice: number;
  type: string;
  term?: string;

  constructor(packOmapiId: string, packPrice: number, subPackOmapiId: string, subPackPrice: number, type = Order.ORDER) {
    this.packOmapiId = packOmapiId;
    this.subPackOmapiId = subPackOmapiId;
    this.packPrice = packPrice;
    this.subPackPrice = subPackPrice;
    this.type = type;
  }

  orderName(): string {
    if (this.subPackOmapiId) {
      return OmapiIdConstants.PRODUCT_NAME_MAP.get(this.packOmapiId) + ', ' + OmapiIdConstants.PRODUCT_NAME_MAP.get(this.subPackOmapiId);
    }
    return OmapiIdConstants.PRODUCT_NAME_MAP.get(this.packOmapiId);
  }

  public getLogoUrl(): string {
    if (this.subPackOmapiId) {
      return ImageUtils.getLogoUrlForOmapiId(this.packOmapiId + '-' + this.subPackOmapiId);
    }
    return ImageUtils.getLogoUrlForOmapiId(this.packOmapiId);

  }

}
